export default __webpack_public_path__ + "static/media/owner.80c17adf.svg";